<script setup>
import { ref } from 'vue';
defineProps({
  is: {
    type: String,
    default: 'div',
  },
  className: {
    type: String,
    default: '',
  },
  childClassName: {
    type: String,
    default: '',
  },
});
const innerRef = ref();
defineExpose({ innerRef });
</script>

<template>
  <component :is="is" :class="['w-full px-4 sm:px-10 lg:px-12', className]">
    <div
      ref="innerRef"
      :class="['mx-auto max-w-7xl 2xl:max-w-[1504px]', childClassName]"
    >
      <slot />
    </div>
  </component>
</template>
